module.exports = __webpack_public_path__ + "static/img/top-img1.59141fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/top-img1.png
// module id = KyUr
// module chunks = 0